import { h, Fragment } from "preact";
import { observer } from "mobx-preact";
import cx from "classnames";
import SmsCodeInput from "../sms-code-input";
import TinyInput from "../tiny-input";
import Toast from "../toast";
import "./index.less";
import Link from "../link";
import { isIE9, isMobile } from "../../utils/device-utils";


const prefix = isMobile() ? "xfe-common-login-mobile" : "xfe-common-login";

const Login = ({ store, className}) => {
  store?.use();
  return <div className={cx(`${prefix}-main`, className)}>

    <div className={`${prefix}-loginWrap`}>
      <div className={`${prefix}-loginTabGroup`}>

        {store?.loginConfig?.passportLoginType?.typesConfig?.length > 0 && store?.loginConfig?.passportLoginType?.typesConfig?.map((item, index) => {
          if (item.type === "passport" && item.enable) {
            return <div className={cx(`${prefix}-tabText`, store?.currentTab === "passport" && `${prefix}-tabActive`, `${prefix}-loginTab`, `${prefix}-link`)} onClick={() => {
              store.onTabClick("passport");
            }}>金山通行证
              {store?.currentTab === "passport" && <div className={`${prefix}-borderBtmLogin`}/>}
            </div>;
          } else if (item.type === "phone" && item.enable) {
            return <div className={cx(`${prefix}-tabText`, store?.currentTab === "phone" && `${prefix}-tabActive`, `${prefix}-phoneLoginTab`, `${prefix}-link`)} onClick={() => {
              store.onTabClick("phone");
            }}>手机登录
              {store?.currentTab === "phone" && <div className={`${prefix}-borderBtm`}/>}
            </div>;
          }
        })}

      </div>


      <form onSubmit={store?.onLoginClick}>
        {!isIE9() && <input type="submit" hidden/>}

        {store?.currentTab === "phone" &&
        <div className={`${prefix}-loginInputContent`}>
          <SmsCodeInput store={store?.smsCodeInput}/>
        </div>}

        {store?.currentTab === "passport" && <div className={`${prefix}-loginInputContent`}>
          {store?.accountMsgConfig?.length > 0 && store?.accountMsgConfig.map((item, index) => {
            return <TinyInput name={item.key} store={item.store} key={index} type={item.type} value={item.store.value} placeholder={item.placeholder} warnTip={item?.warnTip} onBlur={item?.onBlur}/>;
          })}
        </div>}

        <div className={`${prefix}-loginBtnGroup`}>
          <Link className={`${prefix}-loginBtn`} onClick={store.onLoginClick}>立即登录</Link>
          <div className={`${prefix}-otherBtn`}>
            <div className={`${prefix}-forgetBtnGroup`}>
              {store?.loginConfig?.forgetAccount?.enable && <>
                <Link href={store?.loginConfig?.forgetAccount?.url} target="_blank">忘记账号</Link>
                <span className={`${prefix}-separation`}>|</span>
              </>}

              {store?.loginConfig?.forgetPassword?.enable &&
              <Link href={store?.loginConfig?.forgetPassword?.url} target="_blank">忘记密码</Link>}
            </div>
            <Link className={`${prefix}-registerBtn`} onClick={() => {
              store?.onChangeContent(1);
            }}>注册>
            </Link>
          </div>
        </div>

      </form>

      {store?.loginConfig?.thirdLoginType?.length > 0 && <div className={`${prefix}-loginFooter`}>
        <div className={`${prefix}-footerTitle`}>
          <span className={`${prefix}-title`}>其他方式登录</span>
        </div>
        <div className={`${prefix}-loginTypeGroup`}>
          {store?.loginConfig?.thirdLoginType?.map((item) => {
            if (item.enable) {
              return <Link className={`${prefix}-loginTypeItem`} key={item.type} onClick={() => {
                store?.getAuthorizeUrl(item.type);
              }}>
                <div className={`${prefix}-loginTypeIcon`} style={item?.iconUrl && { backgroundImage: `url(${item?.iconUrl})` }}/>
                <div className={`${prefix}-loginTypeText`}>{item.text}</div>
              </Link>;

            } else {
              return null;

            }
          })}

        </div>
      </div>}

    </div>

    <Toast store={store?.toast}/>
  </div>;
};

export default observer(Login);

;
